import React from 'react';
import { StyleSheet, TouchableWithoutFeedback, View } from 'react-native';

const Overlay = ({ children, onClose }: { children: React.ReactNode; onClose: () => void }) => {
	return (
		<View style={styles.root}>
			<TouchableWithoutFeedback onPress={onClose}>
				<View style={styles.backdrop} />
			</TouchableWithoutFeedback>
			{children}
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		position: 'absolute',
		overflow: 'hidden',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 99,
	},
	backdrop: {
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(0,0,0,0.2)',
	},
});

export default Overlay;
